import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Opportunity } from '@vendasta/sales-opportunities';
import { addDays } from 'date-fns';
import { OpportunityService } from '../../../../../../opportunity.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { switchMap, take } from 'rxjs/operators';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'sales-ui-expected-close-selector',
  templateUrl: './expected-close-selector.component.html',
  styleUrls: ['../../opportunity-info-form.component.scss'],
})
export class ExpectedCloseSelectorComponent implements OnInit {
  protected opportunity$: Observable<Opportunity>;
  protected readonly minDate = addDays(new Date(), 1);
  private destroyRef = inject(DestroyRef);

  constructor(private readonly updateService: OpportunityService, private readonly snackbarService: SnackbarService) {}

  ngOnInit(): void {
    this.opportunity$ = this.updateService.currentOpportunity$;
  }

  handleExpectedCloseDateChange($event: MatDatepickerInputEvent<Date>): void {
    this.opportunity$
      .pipe(
        take(1),
        switchMap((opp) => {
          return this.updateService.updateExpectedCloseDate(opp, $event.value);
        }),
      )
      .subscribe((newOpp) => {
        if (newOpp) {
          this.snackbarService.openSuccessSnack('SALES_EXPECTED_CLOSE.EXPECTED_CLOSE_UPDATED');
        } else {
          this.snackbarService.openErrorSnack('SALES_EXPECTED_CLOSE.UNABLE_TO_UPDATE_EXPECTED_CLOSE');
        }
      });
  }
}
